import { deleteApi, getApi, postApi, putApi } from "../helpers/auth_helpers";

/** Zoho Books billing sync (backend module BILLING_SYNC). Every call answers {success, message, code, data}. */
const base = `${process.env.REACT_APP_SERVERURL || ""}/billing-sync/zoho`;

export type ZohoStatus = {
  status: "NOT_CONNECTED" | "PENDING" | "CHOOSE_ORG" | "ACTIVE" | "DISCONNECTED";
  connected: boolean;
  zohoOrgId?: string | null;
  zohoOrgName?: string | null;
  connectedAt?: string | null;
  connectedByName?: string | null;
  callsToday?: number | null;
  dailyCallCap?: number | null;
  /** Memos still held by a Zoho draft. */
  openDrafts?: number | null;
  /** Zoho items HKP made that have no photo yet (never tried, or the upload failed). */
  itemPhotosMissing?: number | null;
};

export type ZohoTaxRate = { rate: string; intraState: boolean; interState: boolean };

export const getZohoStatus = () => getApi(base);
export const startZohoConnect = () => postApi(`${base}/connect`, {});
export const confirmZohoConnect = (confirm: string) => postApi(`${base}/confirm`, { confirm });
export const getZohoOrganizations = () => getApi(`${base}/organizations`);
export const chooseZohoOrganization = (zohoOrgId: string) => putApi(`${base}/organization`, { zohoOrgId });
export const disconnectZoho = () => deleteApi(base);
export const getZohoTaxes = () => getApi(`${base}/taxes`);
export const refreshZohoTaxes = () => postApi(`${base}/taxes`, {});
/** Studio admin: puts the piece photo on up to 20 Zoho items that have none yet. */
export const addZohoItemPhotos = () => postApi(`${base}/items/photos`, {});

export const pushMemoToZoho = (memoId: string) => postApi(`${base}/memos/${encodeURIComponent(memoId)}/push`, {});
export const checkMemoInZoho = (memoId: string) => postApi(`${base}/memos/${encodeURIComponent(memoId)}/refresh`, {});
/** Voids the memo's Zoho draft (never deletes it), then optionally opens the memo for editing or cancels it. */
/** byHand: Zoho is out of HKP's reach; the studio admin confirms they voided it in Zoho, and says how. */
export const voidMemoZohoDraft = (memoId: string, then?: "reopen" | "cancel", cancelReason?: string,
  byHand?: { handReason: string }) =>
  postApi(`${base}/memos/${encodeURIComponent(memoId)}/void`,
    { then, cancelReason, ...(byHand ? { voidedInZoho: true, handReason: byHand.handReason } : {}) });

/** Approval memo out with the buyer: its Zoho delivery challan, and the returned pieces recorded on it. */
export const pushApprovalChallan = (memoId: string) => postApi(`${base}/memos/${encodeURIComponent(memoId)}/challan`, {});
export const syncApprovalReturns = (memoId: string) => postApi(`${base}/memos/${encodeURIComponent(memoId)}/challan/returns`, {});
